import { Card, cx } from "../../components";
import { useSectionReveal } from "../../motion";
import styles from "./Vitrine.module.css";

const ETAPES = [
  {
    numero: "1",
    titre: "Acheter un pack",
    texte:
      "Les tokens sont crédités au portefeuille au taux de la grille du moment. Ce taux est figé sur l'achat et ne bouge plus, quoi qu'il arrive à la grille ensuite.",
  },
  {
    numero: "2",
    titre: "Ouvrir un projet",
    texte:
      "Des expertises, une enveloppe : elle est réservée et le projet démarre, sans nouveau devis ni bon de commande. L'ESN y affecte ses consultants.",
  },
  {
    numero: "3",
    titre: "Suivre au réel",
    texte:
      "Les consultants déclarent leurs jours ; validés, ils s'imputent sur l'enveloppe. À la clôture, le reliquat revient au disponible.",
  },
];

/** Les trois gestes du produit, dans l'ordre où on les fait. */
export function VitrineEtapes() {
  const section = useSectionReveal<HTMLElement>();

  return (
    <section ref={section} id="etapes" className={cx(styles.section, styles.ecran)} aria-labelledby="etapes-titre">
      <div className={styles.sectionEntete} data-anim="reveal">
        <p className={styles.surtitre}>Comment ça marche</p>
        <h2 id="etapes-titre" className={styles.sectionTitre}>
          Trois gestes, un portefeuille.
        </h2>
      </div>
      <ol className={styles.cartes}>
        {ETAPES.map((e) => (
          <Card key={e.numero} as="li" data-anim="reveal" className={styles.carteEtape}>
            <span className={styles.numero} aria-hidden="true">
              {e.numero}
            </span>
            <h3 className={styles.carteTitre}>{e.titre}</h3>
            <p className={styles.carteTexte}>{e.texte}</p>
          </Card>
        ))}
      </ol>
    </section>
  );
}
